import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  import { ActivatedRoute, Router } from '@angular/router';
  import { DatePipe } from '@angular/common';
  
  import { IdentificationService } from '../../services/identification.service';
  
  @Component({
    selector: 'app-identification-detail',
    standalone: true,
    imports: [DatePipe],
    templateUrl: './identification-detail.html',
    styleUrl: './identification-detail.scss',
  })
  export class IdentificationDetailComponent
    implements OnInit
  {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private identificationService =
      inject(IdentificationService);
    private cdr = inject(ChangeDetectorRef);
  
    identification: any = null;
  
    isLoading = true;
  
    isUpdatingStatus = false;
  
    ngOnInit(): void {
      const identificationId =
        this.route.snapshot.paramMap.get('id');
  
      if (!identificationId) {
        this.router.navigate(['/admin/identifications']);
        return;
      }
  
      this.loadIdentification(identificationId);
    }
  
    loadIdentification(id: string): void {
      this.isLoading = true;
  
      this.identificationService
        .getIdentification(id)
        .subscribe({
          next: (response: any) => {
            console.log(
              '🟢 PLACA OBTENIDA:',
              response,
            );
  
            this.identification =
              response.data.document;
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR CARGANDO PLACA:',
              error,
            );
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
        });
    }
  
    updateStatus(status: string): void {
      if (
        !this.identification?._id ||
        this.isUpdatingStatus
      ) {
        return;
      }
  
      this.isUpdatingStatus = true;
  
      this.identificationService
        .updateIdentificationStatus(
          this.identification._id,
          status,
        )
        .subscribe({
          next: (response: any) => {
            console.log(
              '🟢 ESTADO DE PLACA ACTUALIZADO:',
              response,
            );
  
            this.identification =
              response.data.document;
  
            this.isUpdatingStatus = false;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR ACTUALIZANDO ESTADO:',
              error,
            );
  
            this.isUpdatingStatus = false;
  
            this.cdr.detectChanges();
          },
        });
    }
  
    goBack(): void {
      this.router.navigate([
        '/admin/identifications',
      ]);
    }
  }